import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
// 

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';


import { SystemFile } from './../../../../shared/models/systemFile.model';
import { Job } from './../../../../shared/models/job.model';
import { Permission } from './../../../../shared/models/permission.model';
import { SystemLog } from './../../../../shared/models/sysLog.model';
import { DataUtil } from '@syncfusion/ej2-data';


@Component({
  selector: 'app-assign-system-file-widget',
  templateUrl: './assign-system-file-widget.component.html',
  styleUrls: ['./assign-system-file-widget.component.css']
})
export class AssignSystemFileWidgetComponent implements OnInit {


  // Setup the Syncfusion Mulit Select
   // defined the array of data
   public skillset: string[] = [
    'ASP.NET', 'ActionScript', 'Basic',
    'C++' , 'C#' , 'dBase' , 'Delphi' ,
    'ESPOL' , 'F#' , 'FoxPro' , 'Java',
    'J#' , 'Lisp' , 'Logo' , 'PHP'
];
public placeholder: String = 'Attach Copies to These Subjects';

// subject_fields: Object = { text: 'subject_number', value: 'subject_id' };
subject_fields: Object = { text: 'Subject Number', value: 'name' };

skillForm = {
  skillname: null,
  sname: '',
  smail: ''
};



  @Input() file_id?: Observable<any[]>;
  @Input() file_data?: any;
  @Input() permission_check?: boolean;
  file: SystemFile;


   // setup as observable?
   @Input() item_id?: Observable<any[]>; // impliments on changes.
   @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
  returned_file_data: any;
  brand_types: any;
  system_file_data: any;
  system_file_data_original: any;
  permission_model: Permission;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();


  @Input() job_id?; // impliments on changes.
  @Input() subject_id?; // impliments on changes.
  job_subjects_data: Object;
  model: SystemFile;
  job_subject_data: Object;
  selected_file_number: any;
  selected_file_subject_number: any;

  selected_value: any[];

  list : any[];
  list_selected : any[];
  results: any[];
  sub_assigned_to_subjects: any;
  list_a: any[];
  system_log_created_response: any;
  file_created_response: any;
  file_edit_level: string;
  created_file_name: any;
  current_subject_data: any;
  returned_created_file_id: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  sessionUserLevel: any;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  brand_types_data: any;
  job: Object;
  brand_report_id: any;
  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService

  ) {
// My Multi Select
// :: https://stackblitz.com/edit/multiselect-checkbox-dropdown?file=src%2Fapp%2Fapp.component.ts

// now set in load the subjects function below. and includs the hand made componend.

// this.list = 
// [
//   {name :'India',checked : false},
//   {name :'US',checked : false},
//   {name :'China',checked : false},
//   {name :'France',checked : false}
// ];



  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


   }

      // check for changes. to load data.
      ngOnChanges(changes) {
        if (changes.item_id) {
          // deal with asynchronous Observable result
          this.file_id = changes.item_id.currentValue;

          console.log('Sent Subject ID:', this.subject_id);

          // this.getSubjectAgentBrandsAssigned_comms(this.subject_id); // just in case
this.getJob(this.job_id);
          // Loads any agents applicable to the job.
          // this.getSubjectAgentsAssignedAll();



          this.model = new SystemFile();
          // set the form vars and permissions for change
          this.getBrandTypes();
          this.permission_model = new Permission();
          this.permission_model = {
            job_id: this.job_id,
            subject_id: this.subject_id, // this will be blank
            created_by: this.gfunc.sessionUserId,
            created_level: this.gfunc.sessionUserLevel,
            file_brand_id: this.gfunc.sessionBrandId,
            brand_type_id: this.gfunc.sessionBrandTypeId,
            assigned_to_agents: JSON.stringify(this.allAgentRecipients)
            } as Permission;

  

              // load data from sent ID
              if (!this.file_data){
                this.getSystemFile(this.file_id);
              }else{
             // this.file_data = this.returned_file_data;
              }


        }
      }

  ngOnInit() {

    this.allAgentRecipients = []; // to prevent push errors of empty array

  }

  private getAuditTimestamp(): string {
    return this.legalDate.nowAuditIso();
  }







  getSystemFile(file_id){
    this._demoService.getSystemFile(file_id).subscribe(
       data => { 
         this.file_data = data;
         this.system_file_data = data;
         let res = data[0];

         this.system_file_data_original = data;
   
       // see how this loads for the drop down.(multiselect)
        this.model.assigned_to_subjects = res.assigned_to_subjects;


       // this.model.assigned_to_subjects = JSON.parse(res.assigned_to_subjects);// joins comma with a space
      //  console.log(this.model.assigned_to_subjects);
      
      this.getJobSubjects(this.job_id); // subjects drop downs.
      this.getJob(this.job_id); // sets the file_brand_id.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }

    


// Need to upgrade to do a loop for agents to get the items live.
    shareCheckedList(item:any[]){
      console.log('many: ', item);
      // load the agent secirty array on click - only grabs one on mutile
      let  count_of_items = Object.keys(item).length;
      console.log('count of items: ', count_of_items);
      for(let i = 0; i < count_of_items; i++) {
       let res = item[i];
      this.getSubjectAgentBrandsAssigned_bySubjectNumber(item[i]); // the subject number ;
      }

      };

      shareIndividualCheckedList(item:{}) {
      console.log(item);
      // load the agent secirty array on click (Runs in the above function)
      // this.getSubjectAgentBrandsAssigned_bySubjectNumber(item[0]); // the subject number ;
      };
      


    getJobSubjects(job_id){
      this.list_a = [];
      this.list_selected = [];
      this._demoService.getJobSubjects(job_id).subscribe(
         data => { 
           this.job_subjects_data = data;
          let res_data = data;
           
           // setup new mulit-select- list
           let newArr = data
           let  count_of_items = Object.keys(newArr).length;
           for(let i=0;i < count_of_items; i++) {
            let res = newArr[i];
            this.list_a.push({
              name: res.subject_number,
              checked: false,
                });
             this.list_a = this.list_a;
           } // end for

              // saved cell in file to hold assigned to subject records.
              // json passed to remove all escaped chars and turn into JSON object again
          let newArr2 = JSON.parse(this.model.assigned_to_subjects);
          console.log('pased JSOB selected array: ' + newArr2);
         //  let newArrPassed = JSON.parse(JSON.stringify(this.model.assigned_to_subjects));

          let  count_of_selected_items = newArr2.length;
           console.log('Count of Selcted items: ' + count_of_selected_items);
           for(let i=0; i < count_of_selected_items; i++) {
            let res2 = newArr2[i];
            this.list_selected.push({
              name: res2.name,
              checked: res2.checked,
                });
           //  this.list_selected = this.list_selected;
           } // end for

           console.log(this.list_selected);

           // merge two data sets together with reduce fnction
          this.results = [...this.list_selected, ...this.list_a];
          const test_var = [...this.list_selected, ...this.list_a ];

           // now need to work out how to merge the two together.
           // find unique's based upon name.
        // this.results.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
        // arr.filter((v,i,a)=>a.findIndex(t=>(t.place === v.place && t.name===v.name))===i)

        // function removes duplicates in an array.
        // commented out below for testing.
   //     var uniqueArray = this.removeDuplicates(this.results, "name");
       // console.log("uniqueArray is: " + JSON.stringify(uniqueArray));

        var uniqueArray2 = test_var.filter((v,i,a)=>a.findIndex(t=>(t.name === v.name))===i);
        console.log("uniqueArra2y is: " + JSON.stringify(uniqueArray2));

        this.results = uniqueArray2;
        this.list = this.results;

    //    console.log('filtered Results: ' + JSON.stringify(this.results));
    //    console.log('filtered List: ' + JSON.stringify(this.list));

        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
      }


// :: Memoves all duplicates in a functional array 
// :; @ https://www.codegrepper.com/code-examples/typescript/remove+duplicate+objects+based+on+id+from+array+angular+8
removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject  = {};
   
        for(var i in originalArray) {
           lookupObject[originalArray[i][prop]] = originalArray[i];
        }
   
        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
         return newArray;
    }
   


    
      getJobSubject(subject_id){  
        this._demoService.getJobSubject(subject_id).subscribe(
        data => { 
          this.job_subject_data = data;
          let res = data[0]
          this.selected_file_number = res.file_number;
          this.selected_file_subject_number = res.subject_number;
          // I need to turn the string back into an object before iliterating through
          // JSON.stringify(str) --> JSON.parse(str)
       },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
     }


     getJob(job_id) {
      this._demoService.getJobID(job_id).subscribe(
         data => { this.job = data;
          let res = data[0];
          // Run the job data queries.
        //   this.job_type_id = res.job_type_id;
        this.brand_report_id = res.brand_report_id;
        //       // naming
        //  this.getJobType(res.job_type_id);
        //  this.getJobTypeLocation(res.job_type_location_id);
        //  this.getJobTypeCourt(res.job_type_court_id);
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     };






  // need to change this below
  updateSystemFile(model) {
    // model.job_id = this.job_id;
    model.selected_file_number = this.selected_file_number;
    model.selected_file_subject_number = this.selected_file_subject_number;
 
     this._demoService.updateFile(model).subscribe(
  
      data => { // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    //   this.toastr.success('System File Assigned');
    //  this.createJobSubjectsMultiple(model);
      // Subject to reload the manager component parent.
     // TraceCandidateManagerComponent.returned.next(false);
    // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
    // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
this.closeParentModel.emit();
                return true;
      },
      // error => {
      //  // console.error('Error saving Event!');
      //   this.toastr.error('Error saving Document!');
      //   return Observable.throw(error);
      // },
      err => console.error(err),
      () => console.log('done updates')
  );
    }




    

  // need to change this below
  updateSystemFileAssignSubjects(model, permission_model) {
    // model.job_id = this.job_id;

    model.is_encrypted = 0; // Set so null is not set in database.
  
    // :: only needed to change these below whe using the drop down for a single the system now uses multiple, 2022
    // model.selected_file_number = this.selected_file_number;
   // model.selected_file_subject_number = this.selected_file_subject_number;
     // :: @@ turns array in to string of CSV for database entry
  //  model.assigned_to_subjects_string = model.assigned_to_subjects.join(','); // joins comma without a space

if (permission_model.brand_type_id == 95){
  permission_model.brand_type_id_2 = 95 // set to run agents insert below
  permission_model.brand_type_id = 2 // set back to the client
}else{
  permission_model.brand_type_id_2 = '' // set to run agents insert below
  
}

    // see if thiw works instead of inserting array, I want the string.
   // model.assigned_to_subjects =  model.assigned_to_subjects as string;
       // sets the correct field to upldate from check box drop
   
       //   model.assigned_to_subjects = this.list as any as object;
      // :: this is how I insert the user arrays for a file?
      model.assigned_to_subjects = JSON.stringify(this.list);
      //JSON.parse(JSON.stringify(res.assigned_to_subjects));

      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      
    // console.log('Full model: ' + model.assigned_to_subjects);
    // console.log('Full model sting: ' + model.assigned_to_subjects_string);
    // console.log('Full model as sting: ' + model.assigned_to_subjects as string);
    
                this._demoService.updateFileAssignSubjects(model, permission_model).subscribe(
                  data => {


                    console.log('selected file subject number:single: ' + model.file_subject_number);
                      // need a fution to delete the files. first

                      // :: This function deletes all files with assigned_from_file_id == this model.file_id
              //:: TODO: check if I still need to delete first?
              // :: do a test to see if I can share a file again now...  so this way makes the system even better
               //       this.deleteSystemFileAssigned(model);



                      // Now loop through (Inset functions) assigned_to_subjects
                      // need to filter only the checked of the list and not the already existing linked subject.
                      var uniqueArray2 = this.list.filter(obj => {
                        // return obj.checked === true && obj.name !== model.file_subject_number; // cannot same subject number
                        return obj.checked === true; // allows share of same subject number // Nov 2022 upgrade
                      });
                      let newArr2 = uniqueArray2;
                      let  count_of_selected_items = newArr2.length;
                      console.log('assigne file count: ' + count_of_selected_items);
                      for(let i=0; i < count_of_selected_items; i++) {
                      let res2 = newArr2[i];
                      console.log('fake insert: ' +  res2.name);
                  

                      // there is no brand_type_id in the model --- model is empty!!!!
                    
        // two entires if client and agents            
          // now inserts the record as an agent.... if array count is > 0 or =
                      // somehow I need to do a loop if the file is a client and create two versions one for brand_type_id = 2, and one for 3 the agent.

                          // update and set from drop down.
                      model.brand_type_id = permission_model.brand_type_id; // set so that it is not null or 0;

                   // this function creates the file. in a subjects loop selcted.
                      this.createAssignedFiles(model, res2.name); // name: which is subject_number
          


                      //  // removed this check as we want to run this quiery an -- updated dec 2022 to two options and agent share
                      if (permission_model.brand_type_id_2 == 95 && this.allAgentRecipients?.length >= 1){
                        // if (permission_model.brand_type_id_2 == 2 && this.allAgentRecipients?.length >= 1){
                        // // modify the model and insert the file
                      
                        // agent -- new method copy with brand_type_id change.
                       // model.brand_type_id = 3;
                 // changed this to obly runc 
                       this.createAssignedFiles_Agent_Extra_Record(model, res2.name); // name: which is subject_number
                        console.log('Success: We Have also added the selected agents to the file permissions!: new agent_model' , JSON.stringify(model))

                      }



                      } // end for subjects loop

                //   this.toastr.success('System Files Assigned');
                  this.closeParentModel.emit();
                // this.gfunc.globalJobViewSkipRoute(this.job_id);

                  },
                  err => console.error(err),
                  () => console.log('done updates')
              );





 } // end update function
  
    // need to change this below
  editDoc(model) {
    // model.job_id = this.job_id;
     this._demoService.updateSubjectTemplateDoc(model).subscribe(
  
      data => { // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    //   this.toastr.success('Document Updated');
    //  this.createJobSubjectsMultiple(model);
      // Subject to reload the manager component parent.
     // TraceCandidateManagerComponent.returned.next(false);
    // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
    // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
  
                return true;
      },
      // error => {
      //  // console.error('Error saving Event!');
      //   this.toastr.error('Error saving Document!');
      //   return Observable.throw(error);
      // },
      err => console.error(err),
      () => console.log('done updates')
  );
    }
  
  
  
   getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { 
        //  this.brand_types = data; 
         this.brand_types_data = data;
         // need to add a filter so for agent entry security - can only select themself.
// new sysetm to filter only notes for agents views.
// if (this.gfunc.sessionUserLevel == 5) {
  // REMOVES THE AGENT OPTION FROM ASSIGN A FILE
let newArr = Object(data).filter((sbi)=>(sbi.brand_type_id != 'DISABLED')); // User this if filter is needed. // sbi.brand_type_id != 3
// WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
// this.brand_types = DataUtil.parse.parseJson(newArr);
// let filtered_data = [{
//   ...newArr
// }];

// comment out to turn off agent assigning
this.brand_types = DataUtil.parse.parseJson(newArr);
// this.brand_types = data;
// this.grid.refresh();

// } else {
//  // this.subject_services_data = data;
//  this.brand_types_data = data;
//  // this.grid.refresh();
// }
      
      
      
      },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

   deleteSystemFileAssigned(model){
       this._demoService.deleteSystemFileAssigned(model).subscribe(
       data => {},
       err => console.error(err),
       () => console.log('done removing assigned files')
     );
   }
  
 
  
      docView(doc_id) {
        this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
      }
  
      docEdit(doc_id) {
        this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
      }



// :: (this will need to be looped through when allocating.copying a file to multiple subjects)
createAssignedFiles(model, subject_number) {

  // :: Probaly a good idea to look up the subject from the subject number to insert the correct data in the file
 this._demoService.getJobSubjectBySubjectNumber(subject_number).subscribe(
  data => { this.current_subject_data = data;
  let res = data[0];
model.subject_id = res.subject_id;
model.file_number = res.file_number;


// New Oct 2022 assign file rule.
// if either client or agent.
// New rule allows for a client file to also be an agent file if agents are in the array. "assigned to agents array"
if (model.brand_type_id != 1){
  model.file_brand_id = this.brand_report_id; // sets the brand report id so that clients has access to file allocated.
}

// if set to 1 then the file_brand_id = to owner
if (model.brand_type_id == 1){  
  // same as normal
    model.file_brand_id = 94;
  }



console.log('Sent Normal BrandTypeID in Model: ', model.brand_type_id);



// somehow I need to do a loop if the file is a client and create two versions one for brand_type_id = 2, and one for 3 the agent.


  const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random

            const create_file = {
            file_name: model.file_name,
            file_display_name: model.file_display_name,
            file_ext: model.file_ext,
            file_server_location: model.file_server_location,
            file_url: model.file_url,
            file_folder: model.file_folder,
            file_make: 'assigned', // automated / updated / created / uploaded / link_created / assigned
            file_notes: 'File was assigned via orginal, through the file allocation function: file_id= ' + model.file_id,
            file_job_id: this.job_id,
            file_subject_id: model.subject_id,
            file_subject_number: subject_number,
            created_by: this.sessionUserId,
            created_date: this.getAuditTimestamp(),
            created_level: this.sessionUserLevel,
            file_brand_id: model.file_brand_id,
            // file_brand_id: model.brand_report_id,
            file_access_level: model.file_access_level, // ? who can access this file and below (client or agent) use brand_type_id
            is_active: '1',
            file_password: '',
            file_edit_level: model.file_edit_level,   // what level of user can edit this file (manager default)
            updated_by: this.sessionUserId,
            updated_date: this.getAuditTimestamp(),
            prev_file_id: '0',    // if updating
            brand_type_id: model.brand_type_id,  // if an agent or a client file (if a client agents allocated can view the file as well)
            subject_template_doc_id: model.doc_id,
            subject_com_type_id: model.subject_com_type_id,
            random_file_name: random_file_name,
            full_file_name: model.full_file_name,
            job_id: this.job_id,
            file_number: model.file_number,
            file_reference_number: model.file_reference_number,
            // arrays of sending to - based on subject_template_doc - setup
            agent_access_array: JSON.stringify(model.assignedBrandList), // collect current agent ids
            report_access_array: JSON.stringify(model.brand_data), // collect client
            invoice_access_array: JSON.stringify(model.brand_account_data), // collect client
            user_access_array: JSON.stringify(model.brand_user_data), // of selected associated users.
            invoice_id: model.invoice_id,
            assigned_from_file_id: model.file_id, // orginal file id from which new file was created from
            assigned_to_agents: JSON.stringify(this.allAgentRecipients),
            is_encrypted: 0,
            };
            // console.log( (JSON.stringify(this.assignedBrandList)) );
            this.createFile(create_file, subject_number);


  },
  err => console.error(err),
  // () => console.log('done loading candidate for update')
);

}






// :: (this will need to be looped through when allocating.copying a file to multiple subjects)
createAssignedFiles_Agent_Extra_Record(model, subject_number) {

  // :: Probaly a good idea to look up the subject from the subject number to insert the correct data in the file
 this._demoService.getJobSubjectBySubjectNumber(subject_number).subscribe(
  data => { this.current_subject_data = data;
  let res = data[0];
model.subject_id = res.subject_id;
model.file_number = res.file_number;

/// set as a defailt for agent - this inserts the extra data record with agent permissions if a client and agent is selected at onece
// in file allocation process
model.brand_type_id = 3; // !Important.


// New Oct 2022 assign file rule.
// if either client or agent.
// New rule allows for a client file to also be an agent file if agents are in the array. "assigned to agents array"
if (model.brand_type_id != 1){
  model.file_brand_id = this.brand_report_id; // sets the brand report id so that clients has access to file allocated.
}
// if set to 1 then the file_brand_id = to owner
if (model.brand_type_id == 1){  
// same as normal
  model.file_brand_id = 94;
}




console.log('Sent Agent Brand Type in Model: ', model.brand_type_id);



// somehow I need to do a loop if the file is a client and create two versions one for brand_type_id = 2, and one for 3 the agent.


  const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random

            const create_file = {
            file_name: model.file_name,
            file_display_name: model.file_display_name,
            file_ext: model.file_ext,
            file_server_location: model.file_server_location,
            file_url: model.file_url,
            file_folder: model.file_folder,
            file_make: 'assigned', // automated / updated / created / uploaded / link_created / assigned
            file_notes: 'File was assigned via orginal, through the file allocation function: file_id= ' + model.file_id,
            file_job_id: this.job_id,
            file_subject_id: model.subject_id,
            file_subject_number: subject_number,
            created_by: this.sessionUserId,
            created_date: this.getAuditTimestamp(),
            created_level: this.sessionUserLevel,
            file_brand_id: model.file_brand_id,
            // file_brand_id: model.brand_report_id,
            file_access_level: model.file_access_level, // ? who can access this file and below (client or agent) use brand_type_id
            is_active: '1',
            file_password: '',
            file_edit_level: model.file_edit_level,   // what level of user can edit this file (manager default)
            updated_by: this.sessionUserId,
            updated_date: this.getAuditTimestamp(),
            prev_file_id: '0',    // if updating
            brand_type_id: model.brand_type_id,  // if an agent or a client file (if a client agents allocated can view the file as well)
            subject_template_doc_id: model.doc_id,
            subject_com_type_id: model.subject_com_type_id,
            random_file_name: random_file_name,
            full_file_name: model.full_file_name,
            job_id: this.job_id,
            file_number: model.file_number,
            file_reference_number: model.file_reference_number,
            // arrays of sending to - based on subject_template_doc - setup
            agent_access_array: JSON.stringify(model.assignedBrandList), // collect current agent ids
            report_access_array: JSON.stringify(model.brand_data), // collect client
            invoice_access_array: JSON.stringify(model.brand_account_data), // collect client
            user_access_array: JSON.stringify(model.brand_user_data), // of selected associated users.
            invoice_id: model.invoice_id,
            assigned_from_file_id: model.file_id, // orginal file id from which new file was created from
            assigned_to_agents: JSON.stringify(this.allAgentRecipients),
            };
            // console.log( (JSON.stringify(this.assignedBrandList)) );
            this.createFile(create_file, subject_number);


  },
  err => console.error(err),
  // () => console.log('done loading candidate for update')
);

}



createFile(model, subject_number){
  this._demoService.createFile(model).subscribe(
    data => { this.file_created_response = data;
    // need to get the returned ID to send to log create action
  
    this.returned_created_file_id = this.file_created_response.last_insert_id;
    console.log(this.returned_created_file_id);

   const log_action = 'assinged';
   const log_name = 'Job File Assinged: ' + subject_number  + ' - ' + model.full_file_name + '';
   
           const create_sys_log = {
             log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
             log_action: log_action, // automated / updated / created / uploaded / link_created / sent
             created_by: this.sessionUserId,
             created_date: this.getAuditTimestamp(),
             subject_id: model.subject_id,
             job_id: this.job_id,
             job_reference_number: model.job_reference_number,
             file_number: model.file_number,
             reference_number: model.job_reference_number,
             subject_number: model.subject_number,
             log_type_id: '11', // see datatable system_log_types
             created_level: this.sessionUserLevel,
             brand_type_id: model.brand_type_id,
             subject_com_type_id: model.subject_com_type_id,
             subject_template_doc_id: model.doc_id,
             log_name: log_name + ' - ' + this.returned_created_file_id,
             file_id: this.returned_created_file_id,
             invoice_id: model.invoice_id,
             work_order_id: model.work_order_id,
             agent_id: model.agent_id,
           };
           this.createSystemLog(create_sys_log);


    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

createSystemLog(model){
  this._demoService.createSystemLog(model).subscribe(
    data => { this.system_log_created_response = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_bySubjectNumber(subject_number) {

  this.allAgentRecipients = []; // empty first

  this._demoService.getSubjectAgentBrandsAssigned_bySubjectNumber(subject_number).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
      //  this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};




}
